import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Tooltip from '../../Tooltip';

export default class Radio extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired,
    isChecked: PropTypes.bool.isRequired,
    label: PropTypes.string,
    name: PropTypes.string,
    isDisabled: PropTypes.bool,
    description: PropTypes.string,
    hasWrapper: PropTypes.bool,
    tooltipContent: PropTypes.any,
    tooltipTitle: PropTypes.any,
    mapKey: PropTypes.number,
    tooltipHasWrap: PropTypes.bool,
    tooltipCloseByClick: PropTypes.bool,
  };
  state = {
    showTooltip: false,
  };

  setShowTooltip = (value) => {
    this.setState({ showTooltip: value });
  };

  onChange = ({ target: { value } }) => {
    const { onChange } = this.props;
    onChange(value);
  };

  renderTooltip = () => {
    const { tooltipContent, tooltipHasWrap, tooltipCloseByClick, tooltipTitle } = this.props;
    let tooltip = null;
    if (tooltipContent) {
      tooltip = (
        <Tooltip
          content={tooltipContent}
          show={this.state.showTooltip}
          onShow={() => this.setShowTooltip(true)}
          onClose={() => this.setShowTooltip(false)}
          hasWrapper={tooltipHasWrap}
          closeByClick={tooltipCloseByClick}
          title={tooltipTitle}
        />
      );
    }

    return tooltip;
  };

  renderSimpleRadio() {
    const { name, label, value, isChecked, isDisabled, description, hasWrapper } = this.props;
    const labelClassName = classnames('form-radio', {
      'form-radio__disable': isDisabled && !isChecked,
      'form-radio__disable-check': isDisabled && isChecked,
    });
    return (
      <label className={labelClassName}>
        <div className={classnames('jq-radio', { checked: isChecked })}>
          <input
            name={name}
            type="radio"
            checked={isChecked}
            value={value}
            disabled={isDisabled}
            onChange={this.onChange}
          />
          <div className="jq-radio__div" />
        </div>
        {!label ? null : (
          <span className={classnames('form-radio_text', { grey: isDisabled })}>
            {hasWrapper ? <h5>{label}</h5> : label}
            {description ? <p> {description} </p> : null}
          </span>
        )}
      </label>
    );
  }

  renderRadioWithHelpPromt() {
    return (
      <div className="form-group_item">
        <div className="help-wrap help-wrap__inline">
          {this.renderSimpleRadio()}
          {this.renderTooltip()}
        </div>
      </div>
    );
  }

  render() {
    const { tooltipContent } = this.props;
    return tooltipContent ? (
      this.renderRadioWithHelpPromt()
    ) : (
      <div className="form-group_item">{this.renderSimpleRadio()} </div>
    );
  }
}
